import axios from "axios";

const API_URL = "http://localhost:8080/api/auth/";

const register = (username, email, password, phoneNumber) => {
  return axios.post("https://secret-peak-80603.herokuapp.com/api/auth/" + "signup", {
    username,
    email,
    password,
    phoneNumber
  });
};

const login = (username, password) => {
  return axios
    .post("https://secret-peak-80603.herokuapp.com/api/auth/" + "signin", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem("user");
  window.location.reload()
  window.location.replace("/login")
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export default {
  register,
  login,
  logout,
  getCurrentUser,
};
